<script setup lang="ts">
  definePageMeta({
    layout: "reset-password",
    middleware: "un-auth",
  });

  const resetLinkSent = ref(false);

  const email = ref("");

  function handleResetLinkSent(userEmail: string) {
    resetLinkSent.value = true;
    email.value = userEmail;
  }
</script>

<template>
  <div class="space-y-6">
    <div>
      <h1
        class="text-center text-2xl font-bold text-gray-900"
        v-if="!resetLinkSent"
      >
        {{ $t("labels.forgot-password") }}
      </h1>
      <p class="text-center text-gray-500" v-if="!resetLinkSent">
        {{ $t("descriptions.forgot-password") }}
      </p>
    </div>
    <ResetPasswordEmailSent :email="email" v-if="resetLinkSent" />
    <ForgotPasswordForm
      v-else
      @reset-link-sent="handleResetLinkSent"
    />
  </div>
</template>

<style scoped></style>
